<template>
<div>

    <fieldset>
        <div class="form__legend">Fakturační údaje</div>

        <div class="form__row">
            <label for="adr_fakturacni_ulice">Ulice a čp</label>
            <div class="form__controls">
                <input placeholder="Ulice" name="adr_fakturacni_ulice" type="text" v-model="store.adr_fakturacni_ulice">
            </div>
        </div>

        <div class="form__row">
            <label for="adr_fakturacni_mesto">Město</label>
            <div class="form__controls">
                <input placeholder="Město" name="adr_fakturacni_mesto" type="text" v-model="store.adr_fakturacni_mesto">
            </div>
        </div>

        <div class="form__row">
            <label for="adr_fakturacni_psc">PSČ</label>
            <div class="form__controls">
                <input placeholder="PSČ" class="form__input--1/2" name="adr_fakturacni_psc" type="text" v-model="store.adr_fakturacni_psc">
            </div>
        </div>

        <div class="form__row form--required">
            <label for="email">Email</label>
            <div class="form__controls">
                <input placeholder="Email" name="email" type="text" v-model="store.email">
                <div class="form__help">Slouží zároveň pro přihlášení k Vašemu účtu</div>
            </div>
        </div>

        <div class="form__row">
            <label for="adr_fakturacni_telefon">Telefon</label>
            <div class="form__controls">
                <input placeholder="Telefon" name="adr_fakturacni_telefon" type="text" v-model="store.adr_fakturacni_telefon">
            </div>
        </div>

        <div class="form__row form--required">
            <label for="ico">IČ</label>
            <div class="form__controls">
                <input placeholder="IČ" class="form__input--1/2" name="ico" type="text" v-model="store.ico">
            </div>
        </div>

        <div class="form__row">
            <label for="dic">DIČ</label>
            <div class="form__controls">
                <input placeholder="DIČ" class="form__input--1/2" name="dic" type="text" v-model="store.dic">
            </div>
        </div>

    </fieldset>

    <fieldset>

        <div class="form__legend">Kontaktní údaje</div>

        <div class="form__controls--no-label mb-4 text-gray">
            <div v-if="! isExpanded">
                Kontaktní údaje jsou stejné jako fakturační. <a class="btn btn-outline-primary btn-sm" href="#" @click.prevent="isExpanded = true">Změnit</a>
            </div>
            <div v-else>
                <a class="btn btn-outline-primary btn-sm" href="#" @click.prevent="collapseAndEmptyForm()">Použít stejné údaje jako fakturační</a>
            </div>
        </div>

        <div class="form__row" v-show="isExpanded">
            <label for="adr_kontaktni_ulice">Ulice a čp</label>
            <div class="form__controls">
                <input name="adr_kontaktni_ulice" type="text" v-model="store.adr_kontaktni_ulice" :placeholder="store.adr_fakturacni_ulice || 'Ulice'">
            </div>
        </div>

        <div class="form__row" v-show="isExpanded">
            <label for="adr_kontaktni_mesto">Město</label>
            <div class="form__controls">
                <input name="adr_kontaktni_mesto" type="text" v-model="store.adr_kontaktni_mesto" :placeholder="store.adr_fakturacni_mesto || 'Město'">
            </div>
        </div>

        <div class="form__row" v-show="isExpanded">
            <label for="adr_kontaktni_psc">PSČ</label>
            <div class="form__controls">
                <input class="form__input--1/2" name="adr_kontaktni_psc" type="text" v-model="store.adr_kontaktni_psc" :placeholder="store.adr_fakturacni_psc || 'PSČ'">
            </div>
        </div>

        <div class="form__row">
            <div class="form__controls--no-label">
                <label class="form__checkbox">
                    <input type="hidden" name="adr_kontaktni_adresa_public" value="0">
                    <input name="adr_kontaktni_adresa_public" type="checkbox" value="1" :checked="!! + store.adr_kontaktni_adresa_public">
                    zveřejnit kontaktní adresu
                </label>
            </div>
        </div>

        <div class="form__row" v-show="isExpanded">
            <label for="adr_kontaktni_email">Email</label>
            <div class="form__controls">
                <input name="adr_kontaktni_email" type="text" v-model="store.adr_kontaktni_email" :placeholder="store.adr_fakturacni_email || 'Email'">
            </div>
        </div>

        <div class="form__row">
            <div class="form__controls--no-label">
                <label class="form__checkbox">
                    <input type="hidden" name="adr_kontaktni_email_public" value="0">
                    <input name="adr_kontaktni_email_public" type="checkbox" value="1" :checked="!! + store.adr_kontaktni_email_public">
                    zveřejnit kontaktní email
                </label>
            </div>
        </div>

        <div class="form__row" v-show="isExpanded">
            <label for="adr_kontaktni_telefon">Telefon</label>
            <div class="form__controls">
                <input name="adr_kontaktni_telefon" type="text" v-model="store.adr_kontaktni_telefon" :placeholder="store.adr_fakturacni_telefon || 'Telefon'">
            </div>
        </div>

        <div class="form__row">
            <div class="form__controls--no-label">
                <label class="form__checkbox">
                    <input type="hidden" name="adr_kontaktni_telefon_public" value="0">
                    <input name="adr_kontaktni_telefon_public" type="checkbox" value="1" :checked="!! + store.adr_kontaktni_telefon_public">
                    zveřejnit kontaktní telefon
                </label>
            </div>
        </div>

    </fieldset>

</div>
</template>

<script>
export default {
    props: [
        'data'
    ],

    data() {
        return {
            isExpanded: this.data.isExpanded,
            store: this.data
        }
    },

    methods: {
        collapseAndEmptyForm() {
            Object.keys(this.store)
                .map(key => {
                    if (key.indexOf('adr_kontaktni_') == 0 && key.indexOf('_public') < 0) {
                        this.store[key] = null;
                    }
                });

            this.isExpanded = false;
        }
    }


}
</script>
